var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"e404"},[_c('div',{staticClass:"e404bg"}),_c('div',{staticClass:"e404text"},[_vm._v("抱歉，您访问的页面不存在")]),_c('el-button',{staticStyle:{"margin-top":"20px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.to_return}},[_vm._v(" "+_vm._s(_vm.referrer === '' ? '返回首页' : '返回')+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }